import React from 'react'
import { Button, Input } from '@material-tailwind/react'
const AddTestimonial = ({name,designation,content,video,setName,setDesignation,setContent,setVideo,addTestimonial,addImage,addVideo,videoThumbnail,setVideoThumbnail}) => {
  return (
    <div className='ml-[20rem] overflow-scroll' >
          <div className=' py-6' >
        <div className='' >
            <h3 className='font-[NeueBold] text-[2rem] ' >Testimonial</h3>
            <div className='bg-white py-3 my-3 px-6 rounded-lg' >
                <h3 className='font-[NeueMedium]' >Add Testimonial</h3>
                <div>
                <div className='my-3' >
                    <Input value={name} onChange={(e)=>setName(e.target.value)}  label='Enter Name' />
                </div>
                <div className='my-3' >
                    <Input value={designation} onChange={(e)=>setDesignation(e.target.value)} label='Enter Designation' />
                </div>
                <div className='my-3'>
                    <Input value={content} onChange={(e)=>setContent(e.target.value)} label='Enter Testimonial' />
                </div>
        <div>
                     <form  onSubmit={addVideo} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Video</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-center gap-6' >
                   
                   { video.length !==0 &&   <div className='flex items-center justify-start gap-6' >
                   <video width="320" height="240" controls>
                       <source src={video} type="video/mp4" />

                               </video>

                       </div>}
                   
             
           </div>
                <div>
                     <form  onSubmit={addImage} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Thumbnail</Button>
      </form>
      
                </div>
             
                <div className='flex items-center justify-center gap-6' >
                   
                   { videoThumbnail.length !==0 &&   <div className='flex items-center justify-start gap-6' >
                           <img className='w-[200px] h-[200px]' src={videoThumbnail} />
                       </div>}
                   
             
           </div>
                <div className='flex items-center justify-end' >
                    <Button onClick={addTestimonial} >Submit</Button>
                </div>
        </div>
            </div>
           
        </div>
    </div>
    </div>
  )
}

export default AddTestimonial